<template>
  <div
    class="Login"
    v-loading.sync.fullscreen="loading"
  >
    <div style="max-width: 500px; margin: auto">
      <el-card :body-style="{maxWidth: '500px', margin: 'auto'}">
        <h3>登录</h3>
        <el-form
          :model="loginInfo"
          ref="login-form"
        >
          <el-form-item
            label="用户名"
            prop="username"
            :rules="[{required: true, message: '用户名不能为空', trigger: 'blur'}]"
          >
            <el-input
              v-model="loginInfo.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="password"
            :rules="[{required: true, message: '密码不能为空', trigger:'blur'}]"
          >
            <el-input
              type="password"
              v-model="loginInfo.password"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <div style="text-align: center">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-login"
              @click="login"
            >登录</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import User from '@/models/User'


export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      loginInfo: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions({
      'doLogin': 'login'
    }),
    login() {
      this.$refs['login-form'].validate(valid => {
        if(valid) {
          this.loading = true
          this.doLogin(this.loginInfo).then(resp => {
            if(new User(resp).isLogined()) {
              this.$message.success('登录成功')
              this.$router.push({path: '/main'})
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
